import { useMemo, type MutableRefObject, type Ref, type RefCallback } from 'react'

type PossibleRef<T> = Ref<T> | undefined

function assignRef<T>(ref: PossibleRef<T>, value: T | null) {
    if (typeof ref === 'function') {
        ref(value)
        return
    }

    if (ref != null) {
        ;(ref as MutableRefObject<T | null>).current = value
    }
}

export function useMergeRefs<T>(refs: Array<PossibleRef<T>>): RefCallback<T> {
    return useMemo(() => {
        return (value: T | null) => {
            refs.forEach((ref) => assignRef(ref, value))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs)
}
